// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1kDUX","question":"Question_question__1Nt0A","description":"Question_description___8aXN"};